var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"twitter-timeline-container"},[_c('a',{staticClass:"twitter-timeline",attrs:{"data-theme":"dark","href":"https://twitter.com/Openbitlab_node?ref_src=twsrc%5Etfw"}},[_vm._v(" Tweets by Openbitlab_node")])])
}]

export { render, staticRenderFns }